<div class="complete-box">
  <ng-container [ngSwitch]="feedbackStatus.status_code">
    <!-- case when feedback  is open -->
    <ng-container *ngSwitchCase="FEEDBACK_STATUS.OPENED_CODE">
      <div class="complete-box-action">
        <div class="action-complete">
            <core-helpers-forms-button-white [text]="'FEEDBACK COMPLETED'" (submit)="onComplete($event)"></core-helpers-forms-button-white>
            <figure class="action-icon complete-ico"></figure>
        </div>   
      </div>
    </ng-container>
    <!-- case when feedback is completed -->
    <ng-container *ngSwitchCase="FEEDBACK_STATUS.CLOSED_CODE">
      <!-- TODO: add the conditional according the final property from the object " -->
      <div class="complete-box-action completed-artwork" > 
        <!-- the date of completed {{feedback.completed.date | date: 'dd MMM yyyy'}} -->
        <div class="action-message"><span>You Provided Feedback on {{feedbackStatus.date | date: 'dd MMM yyyy'}}</span></div> 
        <figure class="action-icon complete-ico" ></figure>
      </div>
    </ng-container>
    <!-- case when feedback is archived -->
    <ng-container *ngSwitchCase="FEEDBACK_STATUS.ARCHIVED_CODE">
      <!-- TODO: the archived only if needed to show some message or something-->
    </ng-container>
    <!-- Just if we need an default case for the values -->
    <ng-container *ngSwitchDefault>
      <!-- <p>Default option when status doesn't match any case.</p> -->
    </ng-container>
  </ng-container>
  
</div>
